import guides from "../assets/guides.jpg";
import aboutUs from "../assets/yb (23).jpg";
import aboutUs2 from "../assets/yb (52).jpg";

const missionHighlights = [
  {
    title: "Exceptional Wildlife Encounters",
    description:
      "Curated safaris led by expert naturalists who understand Yala’s rhythms and respect its inhabitants.",
    icon: (
      <svg
        className="h-8 w-8"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.5 12c4.5-9 10.5-9 15 0m-15 0c4.5 9 10.5 9 15 0m-15 0h15"
        />
      </svg>
    ),
  },
  {
    title: "Conservation at the Core",
    description:
      "We reinvest in habitat protection, anti-poaching patrols, and research initiatives across Sri Lanka.",
    icon: (
      <svg
        className="h-8 w-8"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 10-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
    ),
  },
  {
    title: "Empowering Communities",
    description:
      "Training, fair employment, and revenue sharing uplift the families who call these buffer zones home.",
    icon: (
      <svg
        className="h-8 w-8"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
  },
  {
    title: "Data-Driven Safaris",
    description:
      "Every drive is logged to monitor wildlife movements, ensuring minimal disturbance and richer sightings.",
    icon: (
      <svg
        className="h-8 w-8"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 3v4a1 1 0 001 1h3m13-5v4a1 1 0 01-1 1h-3M3 21v-4a1 1 0 011-1h3m13 5v-4a1 1 0 00-1-1h-3M9 7h6m-6 5h6m-6 5h6"
        />
      </svg>
    ),
  },
  {
    title: "Uncompromising Safety",
    description:
      "International safety protocols, well-maintained jeeps, and medical readiness keep every guest protected.",
    icon: (
      <svg
        className="h-8 w-8"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6.253v13.5m0-13.5C10.832 5.477 9.017 5.25 7.5 5.25A4.5 4.5 0 003 9.75v6.75A4.5 4.5 0 007.5 21h9a4.5 4.5 0 004.5-4.5V9.75a4.5 4.5 0 00-4.5-4.5c-1.517 0-3.332.227-4.5 1.003z"
        />
      </svg>
    ),
  },
];

const teamMembers = [
  {
    name: "Gayashan Bandara",
    role: "Head Guide",
    bio: "Leading with Experience, Guiding with Heart.",
    image: guides,
  }
];


export default function About() {
  return (
    <div className="mdc-about-page bg-[#1a1f28]">
      <section className="mdc-hero-card">
        <div className="mdc-hero-overlay" />
        <div className="mdc-hero-content">
          <span className="mdc-hero-kicker">About Yala Safari Vibe</span>
          <h1 className="mdc-hero-title">
          Trusted Sri Lanka Safari Experts
          </h1>
          <p className="mdc-hero-text">
          We are a leading Sri Lanka safari tour provider, offering unforgettable wildlife experiences across the country’s most famous national parks, including <b>Yala National Park</b>. Our mission is to deliver safe, well-organized, and authentic safari tours that connect travelers with Sri Lanka’s rich wildlife and natural beauty.
          </p>
          <div className="mdc-hero-actions">
            <button className="mdc-primary-button">
              Plan Your Safari Experience
            </button>
            <div className="mdc-stat-badges">
              <div className="mdc-stat-badge">
                <span className="mdc-dot" />
                <div>
                  <p className="mdc-stat-number">15+ Years</p>
                  <p className="mdc-stat-label">In the wild</p>
                </div>
              </div>
              <div className="mdc-stat-badge">
                <span className="mdc-dot" />
                <div>
                  <p className="mdc-stat-number">10K+ Guests</p>
                  <p className="mdc-stat-label">Hosted safely</p>
                </div>
              </div>
              <div className="mdc-stat-badge">
                <span className="mdc-dot" />
                <div>
                  <p className="mdc-stat-number">98% Rating</p>
                  <p className="mdc-stat-label">Guest satisfaction</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mdc-hero-media">
          <img
            src={aboutUs}
            alt="Yala Safari guides during a game drive"
            className="mdc-hero-media-img"
          />
        </div>
      </section>

      <section className="mdc-section">
        <span className="mdc-chip">
          <span className="mdc-chip-icon" aria-hidden="true"></span>
          Our Story
        </span>
        <h2 className="mdc-section-title">
          From a single jeep to a conservation-focused movement
        </h2>
        <p className="mdc-section-description">
        With a team of <b>experienced safari drivers and professional guides</b>, we specialize in <b>Yala safari tours, wildlife jeep safaris, and custom safari packages for local and international travelers</b>. Our deep knowledge of animal behavior, park routes, and best viewing times ensures a higher chance of spotting <b>leopards, elephants, sloth bears, and exotic bird species</b>.
        </p>

        <div className="mdc-story-grid">
          <div className="mdc-story-card">
            <p>
            We are committed to <b>responsible and sustainable tourism</b>, protecting wildlife while providing high-quality service, comfortable 4×4 jeeps, and personalized safari experiences. Whether you’re a nature lover, wildlife photographer, or family traveler, we tailor each safari to meet your needs.
            </p>
            <p>
            Choose us for reliable service, local expertise, and memorable <b>Sri Lanka wildlife safari tours</b>.
            </p>
            <div className="mdc-story-metrics">
              <div className="mdc-story-metric-card">
                <p className="text-xs font-semibold uppercase text-gray-500">
                  Established
                </p>
                <p className="text-xl font-bold text-[#166534]">2007</p>
                <p className="mt-1 text-sm">
                  Born from a passion for conservation and storytelling.
                </p>
              </div>
              <div className="mdc-story-metric-card">
                <p className="text-xs font-semibold uppercase text-gray-500">
                  Conservation Impact
                </p>
                <p className="text-xl font-bold text-[#166534]">5%</p>
                <p className="mt-1 text-sm">
                  Of every booking supports park research and community projects.
                </p>
              </div>
            </div>
          </div>
          <div className="mdc-image-frame">
            <img
              src={aboutUs2}
              alt="Founder guiding guests through Yala National Park"
              className="mdc-image"
            />
          </div>
        </div>
      </section>

      <section className="mdc-section">
        <span className="mdc-chip">
          <span className="mdc-chip-icon" aria-hidden="true"></span>
          Mission & Values
        </span>
        <h2 className="mdc-section-title">The promises we make to every guest</h2>
        <p className="mdc-section-description">
          Our approach balances immersive experiences with ethical operations.
          These pillars guide every decision we make on and off the trail.
        </p>
        <div className="mdc-feature-grid">
          {missionHighlights.map((item, index) => (
            <div key={index} className="mdc-feature-card">
              <span className="mdc-feature-icon">{item.icon}</span>
              <h3 className="mdc-feature-title">{item.title}</h3>
              <p className="mdc-feature-text">{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mdc-section">
        <span className="mdc-chip">
          <span className="mdc-chip-icon" aria-hidden="true"></span>
          Meet the Guides
        </span>
        <h2 className="mdc-section-title">The experts behind every safari</h2>
        <p className="mdc-section-description">
          Our multilingual guides, trackers, and naturalists are handpicked for
          their field expertise, guest care, and commitment to conservation.
        </p>
        <div className="ui-mdc-team-carousel" style={{ display: "flex", justifyContent: "center" }}>
          {teamMembers[0] && (
            <div className="ui-mdc-team-carousel-slide" style={{ maxWidth: "400px", width: "100%" }}>
              <div className="mdc-team-card">
                <div className="mdc-team-avatar">
                  <img
                    src={teamMembers[0].image}
                    alt={teamMembers[0].name}
                    className="h-full w-full object-cover"
                  />
                </div>
                <h3 className="mdc-team-name">{teamMembers[0].name}</h3>
                <p className="mdc-team-role">{teamMembers[0].role}</p>
                <p className="mdc-team-bio">{teamMembers[0].bio}</p>
              </div>
            </div>
          )}
        </div>
      </section>

      <section className="ui-mdc-mission-section mdc-section">
        <div className="ui-mdc-mission-container">
          <span className="ui-mdc-mission-chip mdc-chip">
            <span className="mdc-chip-icon" aria-hidden="true"></span>
            Our Mission
          </span>
          <h2 className="ui-mdc-mission-title mdc-section-title">
            Preserving wilderness through responsible tourism
          </h2>
          <p className="ui-mdc-mission-description mdc-section-description">
            Our mission is to create transformative wildlife experiences that inspire conservation, 
            support local communities, and ensure the long-term protection of Sri Lanka's natural heritage.
          </p>

          <div className="ui-mdc-mission-content">
            <div className="ui-mdc-mission-primary">
              <div className="ui-mdc-mission-card">
                <div className="ui-mdc-mission-icon">
                  <svg
                    className="h-12 w-12"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                    />
                  </svg>
                </div>
                <h3 className="ui-mdc-mission-card-title">Conservation First</h3>
                <p className="ui-mdc-mission-card-text">
                  Every safari is designed to minimize our ecological footprint while maximizing 
                  positive impact on wildlife protection and habitat preservation.
                </p>
              </div>

              <div className="ui-mdc-mission-card">
                <div className="ui-mdc-mission-icon">
                  <svg
                    className="h-12 w-12"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
                    />
                  </svg>
                </div>
                <h3 className="ui-mdc-mission-card-title">Community Empowerment</h3>
                <p className="ui-mdc-mission-card-text">
                  We invest in local communities through fair employment, training programs, and 
                  revenue sharing that creates sustainable livelihoods around protected areas.
                </p>
              </div>

              <div className="ui-mdc-mission-card">
                <div className="ui-mdc-mission-icon">
                  <svg
                    className="h-12 w-12"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
                    />
                  </svg>
                </div>
                <h3 className="ui-mdc-mission-card-title">Exceptional Experiences</h3>
                <p className="ui-mdc-mission-card-text">
                  We deliver world-class safari experiences that exceed expectations, creating 
                  lasting memories while respecting the natural world we celebrate.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
